import { render, staticRenderFns } from "./addbot-redirect.vue?vue&type=template&id=d13d6de6&"
import script from "./addbot-redirect.vue?vue&type=script&lang=js&"
export * from "./addbot-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports